import React from "react";
import DynamicBlocksList from "./DynamicBlocksList";
import PageMeta from "../../components/common/PageMeta";

const DynamicBlocks = () => {
    return (
        <>
            <PageMeta title="Dynamic Blocks" description="Quản lý Dynamic Blocks"/>
            <div className="space-y-6">
                <DynamicBlocksList />
            </div>
        </>
    );
};

export default DynamicBlocks;

